<script>
    export let in_stock = false;
    export let qty = 0;

    $: is_in_stock = in_stock && qty > 0;
</script>

{#if is_in_stock}
    {#if qty < 5}
        <div class="stock limited_stock">
            <span class="text"> {window.__('product_stock.only_x_in_stock', { qty })}</span>
        </div>
    {:else}
        <div class="stock in_stock">
            <span class="text"> {window.__('product_stock.in_stock', { qty })}</span>
        </div>
    {/if}
{:else}
    <div class="stock out_of_stock">
        <span class="text">{window.__('product_stock.out_of_stock', { qty })} </span>
    </div>
{/if}


<style>/* Disbaled Styles */

    .stock {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media (min-width: 768px) {
        .stock {
            justify-content: flex-start;
        }
    }
    .limited_stock {
        color: var(--red);
    }
</style>